
import metaLogo from '../../../assets/images/meta-logo.png';

export type IntegrationType =
  | 'dropi'
  | 'mercadopago'
  | 'stripe'
  | 'shopify'
  | 'whatsapp'
  | 'meta';

export interface IntegrationUIConfig {
  type: IntegrationType;
  name: string;
  logoSrc: string;
  bgColor: string;
}

export const INTEGRATIONS_UI_CONFIG: Record<IntegrationType, IntegrationUIConfig> = {
  dropi: {
    type: 'dropi',
    name: 'Dropi',
    logoSrc: 'https://dropi.co/wp-content/uploads/2025/04/Logo-dropi-Horizontal.svg',
    bgColor: 'bg-[#EB6F2D]',
  },
  mercadopago: {
    type: 'mercadopago',
    name: 'Mercado Pago',
    logoSrc: 'https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/6.7.73/mercadopago/logo__large@2x.png',
    bgColor: 'bg-transparent',
  },
  stripe: {
    type: 'stripe',
    name: 'Stripe',
    logoSrc: 'https://fluxi.s3.amazonaws.com/dev/assets/fluxi/integrations/logo/stripe-logo-v1.webp',
    bgColor: 'bg-[#625BF6]',
  },
  shopify: {
    type: 'shopify',
    name: 'Shopify',
    logoSrc: 'https://cdn.shopify.com/assets/images/logos/shopify-bag.png',
    bgColor: 'bg-[#95BF47]',
  },
  whatsapp: {
    type: 'whatsapp',
    name: 'WhatsApp Business',
    logoSrc: 'https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg',
    bgColor: 'bg-[#25D366]',
  },
  meta: {
    type: 'meta',
    name: 'Meta Ads',
    logoSrc: metaLogo,
    bgColor: 'bg-transparent',
  },
};
